import { render, staticRenderFns } from "./agentOwnerList.vue?vue&type=template&id=4ccbf566"
import script from "./agentOwnerList.vue?vue&type=script&lang=js"
export * from "./agentOwnerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports